var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard-header"},[_c('span',{staticClass:"chevron",class:{ rotate: !_vm.open }},[_c('i',{staticClass:"fa-light fa-chevron-down"})]),_c('h3',[_vm._t("header")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }